import { createSlice } from "@reduxjs/toolkit";
import { getTopRegions } from "./topRegionsAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  regionsData: [],
  latestRequestId: null,
};

const topRegions = createSlice({
  name: "topRegions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTopRegions.pending, (state, action) => {
        state.loading = true;
        state.regionsData = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getTopRegions.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.regionsData = action.payload;
        state.error = null;
      })
      .addCase(getTopRegions.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default topRegions.reducer;
